/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsstripeStripeIntegration model module.
 * @module model/IntegrationsstripeStripeIntegration
 * @version v0.3
 */
export default class IntegrationsstripeStripeIntegration {
  /**
   * Constructs a new <code>IntegrationsstripeStripeIntegration</code>.
   * @alias module:model/IntegrationsstripeStripeIntegration
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsstripeStripeIntegration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsstripeStripeIntegration} obj Optional instance to populate.
   * @return {module:model/IntegrationsstripeStripeIntegration} The populated <code>IntegrationsstripeStripeIntegration</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsstripeStripeIntegration();
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('external_action_required'))
        obj.externalActionRequired = ApiClient.convertToType(data['external_action_required'], 'Boolean');
      if (data.hasOwnProperty('account_id'))
        obj.accountId = ApiClient.convertToType(data['account_id'], 'String');
      if (data.hasOwnProperty('integration_type'))
        obj.integrationType = ApiClient.convertToType(data['integration_type'], 'String');
      if (data.hasOwnProperty('webhook_signature_key'))
        obj.webhookSignatureKey = ApiClient.convertToType(data['webhook_signature_key'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Boolean} enabled
 */
IntegrationsstripeStripeIntegration.prototype.enabled = undefined;

/**
 * @member {Boolean} externalActionRequired
 */
IntegrationsstripeStripeIntegration.prototype.externalActionRequired = undefined;

/**
 * @member {String} accountId
 */
IntegrationsstripeStripeIntegration.prototype.accountId = undefined;

/**
 * Allowed values for the <code>integrationType</code> property.
 * @enum {String}
 * @readonly
 */
IntegrationsstripeStripeIntegration.IntegrationTypeEnum = {
  /**
   * value: "stripe_connect"
   * @const
   */
  connect: "stripe_connect",

  /**
   * value: "stripe_individual"
   * @const
   */
  individual: "stripe_individual"
};
/**
 * @member {module:model/IntegrationsstripeStripeIntegration.IntegrationTypeEnum} integrationType
 */
IntegrationsstripeStripeIntegration.prototype.integrationType = undefined;

/**
 * @member {String} webhookSignatureKey
 */
IntegrationsstripeStripeIntegration.prototype.webhookSignatureKey = undefined;

